import { useEffect, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'shared/hooks/useAuth';
import { UserRole } from 'shared/types/user';
import { ROUTES } from 'shared/constants/routes';

interface ProtectedRouteProps {
  allowedRoles?: UserRole[];
}

// Projeto de apresentação: nenhuma tela fica bloqueada. Se o link acessado
// exige um papel diferente da persona atual, trocamos a persona automaticamente
// em vez de redirecionar para um login ou uma página de acesso negado.
//
// Essa troca automática só vale na CHEGADA à rota (link direto, atualizar a página).
// Se a persona muda enquanto a tela já está aberta (barra "modo apresentação"), a
// escolha é do usuário: saímos para a home em vez de desfazer a troca — senão clicar
// em "Visitante" dentro do painel da arena voltava na hora para "Dono de Arena".
export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { user, isLoading, impersonate } = useAuth();
  const needsSwitch = Boolean(allowedRoles && (!user || !allowedRoles.includes(user.role)));
  const hasBeenAuthorized = useRef(false);

  if (!isLoading && !needsSwitch) hasBeenAuthorized.current = true;
  const personaChangedHere = needsSwitch && hasBeenAuthorized.current;

  useEffect(() => {
    if (!isLoading && needsSwitch && !personaChangedHere && allowedRoles) {
      impersonate(allowedRoles[0]);
    }
  }, [isLoading, needsSwitch, personaChangedHere, allowedRoles, impersonate]);

  if (personaChangedHere) return <Navigate to={ROUTES.HOME} replace />;

  if (isLoading || needsSwitch) {
    return <p className="px-4 py-12 text-center text-sm text-ink-secondary">Carregando...</p>;
  }

  return <Outlet />;
}
